module.exports = __webpack_public_path__ + "img/resize_src.0112c523.png";